/**
 * @description 接口文档API,用于后端接口查询
 * @param
 *   url:后端接口url（必需）
 *   method:后端接口方法（必需）
 *   desc:后端接口描述 （可选）
 *   param:接口参数 （可选）
 *     desc:参数描述（可选）
 */

const api = {
  login: {
    url: '/api_token_auth/',
    method: 'post',
    desc: '登录',
    param: {

    }
  },
  automaticStation: {
    url: '/api/v1/station',
    method: 'get',
    desc: '获取自动站列表',
    param: {

    }
  },
  automaticStationInfo: {
    url: '/api/v1/station/:id/',
    method: 'get',
    desc: '获取自动站列表详情',
    param: {

    }
  },
  devicesInfo: {
    url: '/api/v1/device/:id/',
    method: 'get',
    desc: '电离室详情',
    param: {

    }
  },
  realTimeDatas: {
    url: '/api/v1/device/data/latest/',
    method: 'get',
    desc: '获取电离室实时数据',
    param: {

    }
  },
  realTimeDataField: {
    url: '/api/v1/device/data/field/',
    method: 'get',
    desc: '获取电离室实时数据单位字段',
    param: {

    }
  },
  statisticsList: {
    url: '/api/v1/device/device_menu/',
    method: 'get',
    desc: '获取统计数据菜单',
    param: {

    }
  },
  inspectRealTimeData: {
    url: '/api/v1/device/data/check/',
    method: 'get',
    desc: '获取统计数据菜单',
    param: {

    }
  },
  echartsData: {
    url: '/api/v1/device/data/stat/',
    method: 'get',
    desc: '获取echarts相关数据',
    param: {

    }
  },
  echartsDataDownCsv: {
    url: '/api/v1/device/data/csv/',
    method: 'get',
    down: 'csv',
    desc: '下载echarts相关数据',
    param: {

    }
  },
  echartsAchieve: {
    url: '/api/v1/device/data/receive/',
    method: 'get',
    desc: 'echarts数据获取率数据',
    param: {

    }
  },
  echartsAchieveDownCsv: {
    url: '/api/v1/device/data/receive_csv/',
    method: 'get',
    down: 'csv',
    desc: '下载echarts数据获取率数据',
    param: {

    }
  },
  echartsAchieveUpdate: {
    url: '/api/v1/device/data/retransmission/',
    method: 'post',
    desc: '获取率数据补传',
    param: {

    }
  },
  getHpgeData: {
    url: '/api/v1/device/:id/hpeg_data_analyse/',
    method: 'get',
    desc: '获取高纯锗能谱仪系统设备的最新核素分析报告',
    param: {

    }
  },
  nuclideIdentification: {
    url: '/api/v1/device/hpeg/data/',
    method: 'get',
    desc: '高纯锗能谱仪系统数据分析',
    param: {

    }
  },
  downloadNuclide: {
    url: '/api/v1/device/hpeg/data/:id/download_hpeg_file/',
    method: 'get',
    desc: '高纯锗能谱仪系统文件下载',
    down: 'down',
    param: {

    }
  },
  nuclideAnalysis: {
    url: '/api/v1/device/hpeg/data/:id/parse_rpt_data/',
    method: 'get',
    desc: '核素分析报告',
    param: {

    }
  },
  stationList: {
    url: '/api/v1/device/:id/device_detail/',
    method: 'get',
    desc: '设备自动站列表',
    param: {

    }
  },
  alarmList: {
    url: '/api/v1/alarm/record/',
    method: 'get',
    desc: '报警消息列表',
    param: {

    }
  },
  alarmSign: {
    url: '/api/v1/alarm/record/mark_as_read/',
    method: 'get',
    desc: '报警标记已读',
    param: {

    }
  },
  getAlarmNum: {
    url: '/api/v1/alarm/record/unread_count/',
    method: 'get',
    desc: '报警未读数量',
    param: {

    }
  },
  airosolStatusData: {
    url: '/api/v1/device/:id/airosol_status_data/',
    method: 'get',
    desc: '全自动气溶胶 Status 数据',
    param: {

    }
  },
  hpgeAtlas: {
    url: '/api/v1/device/:id/hpge_atlas/',
    method: 'get',
    desc: '实时谱图',
    param: {

    }
  },
  alarmSetting: {
    url: '/api/v1/alarm/setting/all_settings/',
    method: 'get',
    desc: '报警设置消息',
    param: {

    }
  },
  updateAlarmSetting: {
    url: '/api/v1/alarm/setting/save_settings/',
    method: 'post',
    desc: '更新报警设置',
    param: {

    }
  },
}

export default api;



// WEBPACK FOOTER //
// ./src/api/api.js